'use client'

import React, { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { getBadgeColors } from '../../CustomTableColumnsConfig'

// Americas
import AR from 'country-flag-icons/react/3x2/AR'
import BO from 'country-flag-icons/react/3x2/BO'
import BR from 'country-flag-icons/react/3x2/BR'
import CA from 'country-flag-icons/react/3x2/CA'
import CL from 'country-flag-icons/react/3x2/CL'
import CO from 'country-flag-icons/react/3x2/CO'
import CR from 'country-flag-icons/react/3x2/CR'
import CU from 'country-flag-icons/react/3x2/CU'
import DO from 'country-flag-icons/react/3x2/DO'
import EC from 'country-flag-icons/react/3x2/EC'
import GT from 'country-flag-icons/react/3x2/GT'
import HN from 'country-flag-icons/react/3x2/HN'
import MX from 'country-flag-icons/react/3x2/MX'
import NI from 'country-flag-icons/react/3x2/NI'
import PA from 'country-flag-icons/react/3x2/PA'
import PE from 'country-flag-icons/react/3x2/PE'
import PR from 'country-flag-icons/react/3x2/PR'
import PY from 'country-flag-icons/react/3x2/PY'
import SV from 'country-flag-icons/react/3x2/SV'
import US from 'country-flag-icons/react/3x2/US'
import UY from 'country-flag-icons/react/3x2/UY'
import VE from 'country-flag-icons/react/3x2/VE'
// Europe
import AT from 'country-flag-icons/react/3x2/AT'
import BE from 'country-flag-icons/react/3x2/BE'
import CH from 'country-flag-icons/react/3x2/CH'
import CZ from 'country-flag-icons/react/3x2/CZ'
import DE from 'country-flag-icons/react/3x2/DE'
import DK from 'country-flag-icons/react/3x2/DK'
import ES from 'country-flag-icons/react/3x2/ES'
import FI from 'country-flag-icons/react/3x2/FI'
import FR from 'country-flag-icons/react/3x2/FR'
import GB from 'country-flag-icons/react/3x2/GB'
import GR from 'country-flag-icons/react/3x2/GR'
import HU from 'country-flag-icons/react/3x2/HU'
import IE from 'country-flag-icons/react/3x2/IE'
import IT from 'country-flag-icons/react/3x2/IT'
import NL from 'country-flag-icons/react/3x2/NL'
import NO from 'country-flag-icons/react/3x2/NO'
import PL from 'country-flag-icons/react/3x2/PL'
import PT from 'country-flag-icons/react/3x2/PT'
import RO from 'country-flag-icons/react/3x2/RO'
import RU from 'country-flag-icons/react/3x2/RU'
import SE from 'country-flag-icons/react/3x2/SE'
import UA from 'country-flag-icons/react/3x2/UA'
// Asia
import AE from 'country-flag-icons/react/3x2/AE'
import CN from 'country-flag-icons/react/3x2/CN'
import HK from 'country-flag-icons/react/3x2/HK'
import ID from 'country-flag-icons/react/3x2/ID'
import IL from 'country-flag-icons/react/3x2/IL'
import IN from 'country-flag-icons/react/3x2/IN'
import JP from 'country-flag-icons/react/3x2/JP'
import KR from 'country-flag-icons/react/3x2/KR'
import MY from 'country-flag-icons/react/3x2/MY'
import PH from 'country-flag-icons/react/3x2/PH'
import PK from 'country-flag-icons/react/3x2/PK'
import SA from 'country-flag-icons/react/3x2/SA'
import SG from 'country-flag-icons/react/3x2/SG'
import TH from 'country-flag-icons/react/3x2/TH'
import TR from 'country-flag-icons/react/3x2/TR'
import TW from 'country-flag-icons/react/3x2/TW'
import VN from 'country-flag-icons/react/3x2/VN'
// Africa & Oceania
import AU from 'country-flag-icons/react/3x2/AU'
import EG from 'country-flag-icons/react/3x2/EG'
import MA from 'country-flag-icons/react/3x2/MA'
import NG from 'country-flag-icons/react/3x2/NG'
import NZ from 'country-flag-icons/react/3x2/NZ'
import ZA from 'country-flag-icons/react/3x2/ZA'

const countryFlags: Record<string, any> = {
  // Americas
  'Argentina': AR, 'Bolivia': BO, 'Brasil': BR, 'Canadá': CA, 'Chile': CL,
  'Colombia': CO, 'Costa Rica': CR, 'Cuba': CU, 'República Dominicana': DO,
  'Ecuador': EC, 'El Salvador': SV, 'Estados Unidos': US, 'Guatemala': GT,
  'Honduras': HN, 'México': MX, 'Nicaragua': NI, 'Panamá': PA, 'Paraguay': PY,
  'Perú': PE, 'Puerto Rico': PR, 'Uruguay': UY, 'Venezuela': VE,
  // Europe
  'Alemania': DE, 'Austria': AT, 'Bélgica': BE, 'Dinamarca': DK, 'España': ES,
  'Finlandia': FI, 'Francia': FR, 'Grecia': GR, 'Hungría': HU, 'Irlanda': IE,
  'Italia': IT, 'Noruega': NO, 'Países Bajos': NL, 'Polonia': PL, 'Portugal': PT,
  'Reino Unido': GB, 'República Checa': CZ, 'Rumania': RO, 'Rusia': RU,
  'Suecia': SE, 'Suiza': CH, 'Ucrania': UA,
  // Asia
  'Arabia Saudita': SA, 'China': CN, 'Corea del Sur': KR, 'Emiratos Árabes': AE,
  'Filipinas': PH, 'Hong Kong': HK, 'India': IN, 'Indonesia': ID, 'Israel': IL,
  'Japón': JP, 'Malasia': MY, 'Pakistán': PK, 'Singapur': SG, 'Tailandia': TH,
  'Taiwán': TW, 'Turquía': TR, 'Vietnam': VN,
  // Africa & Oceania
  'Australia': AU, 'Egipto': EG, 'Marruecos': MA, 'Nigeria': NG,
  'Nueva Zelanda': NZ, 'Sudáfrica': ZA,
}

interface SelectOption { value: string; label: string }

interface Props {
  value: string
  options: SelectOption[]
  onChange: (value: string) => void
  onBlur: () => void
  onKeyDown: (e: React.KeyboardEvent) => void
  columnType: 'country' | 'badge' | 'text'
  colId: string
  isDarkMode?: boolean
  allowCreate?: boolean
  onCreateOption?: (value: string) => Promise<void>
}

export default function CustomSelectDropdown({
  value,
  options,
  onChange,
  onBlur,
  onKeyDown,
  columnType,
  colId,
  isDarkMode = false,
  allowCreate = false,
  onCreateOption,
}: Props) {
  const [isOpen, setIsOpen] = useState(true)
  const [selectedValue, setSelectedValue] = useState(value || '')
  const [searchTerm, setSearchTerm] = useState('')
  const [highlightedIndex, setHighlightedIndex] = useState(0)
  const [dropdownPosition, setDropdownPosition] = useState<{
    top: number; left: number; width: number; maxHeight?: number; isMobile?: boolean
  } | null>(null)

  const containerRef = useRef<HTMLDivElement>(null)
  const listRef = useRef<HTMLUListElement>(null)
  const searchInputRef = useRef<HTMLInputElement>(null)

  const filteredOptions = searchTerm
    ? options.filter(opt =>
        opt.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        opt.value.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : options

  const shouldShowCreateButton = allowCreate === true

  useEffect(() => {
    if (!containerRef.current || !isOpen) return
    const rect = containerRef.current.getBoundingClientRect()
    const isMobile = window.innerWidth < 768
    const viewportHeight = window.innerHeight
    const viewportWidth = window.innerWidth

    if (isMobile) {
      setDropdownPosition({
        top: viewportHeight * 0.15,
        left: 16,
        width: viewportWidth - 32,
        maxHeight: viewportHeight * 0.7,
        isMobile: true,
      })
    } else {
      const spaceBelow = viewportHeight - rect.bottom
      let top = rect.bottom + 2
      let maxHeight = Math.min(320, spaceBelow - 10)

      if (spaceBelow < 200 && rect.top > spaceBelow) {
        maxHeight = Math.min(320, rect.top - 10)
        top = rect.top - maxHeight - 2
      }

      setDropdownPosition({
        top,
        left: rect.left,
        width: Math.max(rect.width, 200),
        maxHeight: Math.max(150, maxHeight),
        isMobile: false,
      })
    }
  }, [isOpen])

  useEffect(() => {
    const timeout = setTimeout(() => searchInputRef.current?.focus(), 50)
    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (containerRef.current && !containerRef.current.contains(target) && !target.closest('.custom-dropdown-portal')) {
        setIsOpen(false)
        onBlur()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onBlur])

  useEffect(() => {
    if (isOpen && highlightedIndex >= 0 && listRef.current) {
      const el = listRef.current.children[highlightedIndex] as HTMLElement
      el?.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
    }
  }, [highlightedIndex, isOpen])

  const handleSelect = async (optionValue: string) => {
    const isNewOption = !options.find(opt => opt.value === optionValue || opt.label === optionValue)
    if (isNewOption && onCreateOption) {
      try { await onCreateOption(optionValue) } catch {}
    }
    setSelectedValue(optionValue)
    onChange(optionValue)
    setIsOpen(false)
    onBlur()
  }

  const handleKeyDownInternal = (e: React.KeyboardEvent) => {
    const totalItems = (shouldShowCreateButton ? 1 : 0) + filteredOptions.length

    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setHighlightedIndex(prev => Math.min(prev + 1, totalItems - 1))
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setHighlightedIndex(prev => Math.max(prev - 1, 0))
    } else if (e.key === 'Enter') {
      e.preventDefault()
      const trimmed = searchTerm.trim()
      if (allowCreate && trimmed && !options.find(o => o.value.toLowerCase() === trimmed.toLowerCase())) {
        handleSelect(trimmed)
      } else if (shouldShowCreateButton && highlightedIndex === 0 && trimmed) {
        handleSelect(trimmed)
      } else {
        const adjustedIdx = shouldShowCreateButton ? highlightedIndex - 1 : highlightedIndex
        if (adjustedIdx >= 0 && adjustedIdx < filteredOptions.length) {
          handleSelect(filteredOptions[adjustedIdx].value)
        }
      }
      onKeyDown(e)
    } else if (e.key === 'Escape') {
      e.preventDefault()
      setIsOpen(false)
      onKeyDown(e)
    }
  }

  const renderOption = (option: SelectOption, isHighlighted: boolean, isSelected: boolean) => {
    const baseStyle: React.CSSProperties = {
      padding: '4px 8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      backgroundColor: isHighlighted ? 'rgba(18,124,243,0.12)' : isSelected ? 'rgba(18,124,243,0.06)' : 'transparent',
      borderLeft: isSelected ? '3px solid #127CF3' : '3px solid transparent',
      minHeight: 26,
    }

    if (columnType === 'country') {
      const Flag = countryFlags[option.value]
      return (
        <div style={baseStyle}>
          {Flag && <Flag style={{ width: 18, height: 12, borderRadius: 2 }} />}
          <span style={{ fontSize: 12, fontWeight: isSelected ? 600 : 400 }}>{option.label}</span>
        </div>
      )
    }

    if (columnType === 'badge') {
      const colors = getBadgeColors(option.value, isDarkMode)
      return (
        <div style={baseStyle}>
          <span style={{
            backgroundColor: colors.bg,
            color: colors.text,
            padding: '3px 8px',
            borderRadius: 3,
            fontSize: 11,
            fontWeight: 500,
          }}>
            {option.label}
          </span>
        </div>
      )
    }

    return (
      <div style={baseStyle}>
        <span style={{ fontSize: 12, fontWeight: isSelected ? 600 : 400 }}>{option.label}</span>
      </div>
    )
  }

  const dropdownContent = isOpen && dropdownPosition ? (
    <>
      {dropdownPosition.isMobile && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 99998,
            backdropFilter: 'blur(2px)',
          }}
          onMouseDown={(e) => { e.preventDefault(); setIsOpen(false); onBlur() }}
        />
      )}
      <div
        className="custom-dropdown-portal"
        style={{
          position: 'fixed',
          top: dropdownPosition.top,
          left: dropdownPosition.left,
          width: dropdownPosition.width,
          backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
          color: isDarkMode ? '#e0e0e0' : '#1a1a1a',
          border: dropdownPosition.isMobile ? 'none' : '2px solid #127CF3',
          borderRadius: dropdownPosition.isMobile ? 12 : 6,
          boxShadow: isDarkMode ? '0 8px 24px rgba(0,0,0,0.6)' : '0 8px 24px rgba(18,124,243,0.25)',
          zIndex: 99999,
          maxHeight: dropdownPosition.maxHeight || 280,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ padding: dropdownPosition.isMobile ? '12px 16px' : 8, borderBottom: `1px solid ${isDarkMode ? '#333' : '#e5e7eb'}` }}>
          <input
            ref={searchInputRef}
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setHighlightedIndex(0) }}
            onKeyDown={handleKeyDownInternal}
            style={{
              width: '100%',
              padding: dropdownPosition.isMobile ? '10px 12px' : '6px 8px',
              border: `1px solid ${isDarkMode ? '#444' : '#d1d5db'}`,
              borderRadius: dropdownPosition.isMobile ? 8 : 4,
              fontSize: dropdownPosition.isMobile ? 14 : 12,
              backgroundColor: isDarkMode ? '#2a2a2a' : '#ffffff',
              color: isDarkMode ? '#e0e0e0' : '#1a1a1a',
              outline: 'none',
            }}
          />
        </div>

        <div style={{ flex: 1, overflowY: 'auto', maxHeight: (dropdownPosition.maxHeight || 280) - 60 }}>
          <ul ref={listRef} style={{ listStyle: 'none', margin: 0, padding: 3 }}>
            {shouldShowCreateButton && (
              <li
                onMouseDown={(e) => { e.preventDefault(); if (searchTerm.trim()) handleSelect(searchTerm) }}
                onMouseEnter={() => setHighlightedIndex(0)}
                style={{
                  borderRadius: 3,
                  padding: '6px 10px',
                  cursor: searchTerm.trim() ? 'pointer' : 'default',
                  backgroundColor: highlightedIndex === 0 ? 'rgba(18,124,243,0.12)' : 'transparent',
                  borderLeft: highlightedIndex === 0 ? '3px solid #127CF3' : '3px solid transparent',
                  minHeight: 32,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  marginBottom: 6,
                  borderBottom: `1px solid ${isDarkMode ? '#333' : '#e5e7eb'}`,
                  paddingBottom: 10,
                  opacity: searchTerm.trim() ? 1 : 0.7,
                }}
              >
                {searchTerm.trim() ? (
                  <>
                    <span style={{ fontSize: 16 }}>✨</span>
                    <span style={{
                      ...getBadgeColors(searchTerm, isDarkMode),
                      backgroundColor: getBadgeColors(searchTerm, isDarkMode).bg,
                      color: getBadgeColors(searchTerm, isDarkMode).text,
                      padding: '4px 10px',
                      borderRadius: 4,
                      fontSize: 11,
                      fontWeight: 600,
                    }}>
                      {searchTerm}
                    </span>
                    <span style={{ fontSize: 10, color: isDarkMode ? '#9ca3af' : '#6b7280', marginLeft: 'auto' }}>
                      Create new
                    </span>
                  </>
                ) : (
                  <>
                    <span style={{ fontSize: 16 }}>✨</span>
                    <span style={{ fontSize: 11, color: isDarkMode ? '#9ca3af' : '#6b7280', fontStyle: 'italic' }}>
                      Type to create new option...
                    </span>
                  </>
                )}
              </li>
            )}

            {filteredOptions.map((option, index) => {
              const actualIndex = shouldShowCreateButton ? index + 1 : index
              return (
                <li
                  key={option.value}
                  onMouseDown={(e) => { e.preventDefault(); handleSelect(option.value) }}
                  onMouseEnter={() => setHighlightedIndex(actualIndex)}
                  style={{ borderRadius: 3, overflow: 'hidden' }}
                >
                  {renderOption(option, highlightedIndex === actualIndex, selectedValue === option.value)}
                </li>
              )
            })}

            {!shouldShowCreateButton && filteredOptions.length === 0 && (
              <li style={{ padding: '12px 8px', textAlign: 'center', color: '#9ca3af', fontSize: 11 }}>
                No results found
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  ) : null

  return (
    <>
      <div
        ref={containerRef}
        tabIndex={0}
        onKeyDown={handleKeyDownInternal}
        onBlur={(e) => {
          if (!containerRef.current?.contains(e.relatedTarget as Node)) onBlur()
        }}
        style={{ width: '100%', height: '100%', outline: 'none', display: 'flex', alignItems: 'center', padding: '0 4px' }}
      >
        <span style={{ visibility: 'hidden', fontSize: 11 }}>Editing...</span>
      </div>
      {typeof window !== 'undefined' && dropdownContent && createPortal(dropdownContent, document.body)}
    </>
  )
}
